const state = {
    serverList: [], // 全部服务器列表
    selectedServer: null,
    // selectedServer: null,
};

const mutations = {
    SET_SERVER_LIST(state, serverList) {
        state.serverList = serverList;
        localStorage.setItem("serverList", JSON.stringify(serverList));
    },
    SET_SELECTED_SERVER(state, server) {
        state.selectedServer = server;
        localStorage.setItem("selectedServer", JSON.stringify(server));
    },
};

const getters = {
    getServerList: (state) => state.serverList,
    getSelectedServer: (state) => state.selectedServer,
};

export default {
    namespaced: true,
    state,
    mutations,
    getters,
};